import "./partners.scss";
import { images } from "../../constants";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";

const Partners = () => {
  return (
    <section className="partner-section">
      <h3>OUR PARTNERS</h3>
      <Swiper
        slidesPerView={7}
        spaceBetween={30}
        navigation
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        modules={[Autoplay, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={images.Partner1} alt="partner-1"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner2} alt="partner-2"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner3} alt="partner-3"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner4} alt="partner-4"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner5} alt="partner-5"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner6} alt="partner-6"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner5} alt="partner-5"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner6} alt="partner-6"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner1} alt="partner-1"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner3} alt="partner-3"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner5} alt="partner-5"/>
        </SwiperSlide>
        <SwiperSlide>
          <img src={images.Partner7} alt="partner-7"/>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default Partners;
